import React, {Component} from 'react';

import '../../Frontpage.css';

import '../../common_styles/table.css'
import FigureCalculator from "../../FigureCalculator";
import MapWrapper from "./MapWrapper";
import {Button} from "jjfw";
import Chart from "../statistics/Chart";
import {getFormatFunction} from "../statistics/format";
import {Link} from "@reach/router";

const FC = FigureCalculator

export default class Summary extends Component {

    constructor(props) {
        super(props);

        this.state = {
            trees: this.props.location.state.samples.reduce((a,b)=>a.concat(b.trees[0]),[]),
            samples: this.props.location.state.samples,
            diameterDist: "all"
        };
    }

    render() {
        return (
            <div>
                <div style={{float: "left", padding: 10, margin: 25, backgroundColor: "white", border: "1px solid lightgrey", display: "inline-block", width: 854}}>
                    <div style={{width: "100%", height: 40, borderBottom: "1px solid black"}}>
                        Summary
                        <div style={{float: "right"}}>
                            <Link to="../"><Button text="Go Back"/></Link>
                        </div>
                    </div>
                <header>
                    <div style={{height: window.innerHeight - 50, float: "left", margin: 20}}>
                        <br/>
                        <table className="ar-table">
                            <thead>
                            <tr>
                                <th>Tree</th>
                                <th>Diameter (QMD - cm)</th>
                                <th>Height (Lorey´s m)</th>
                                <th>Basal Area (m2)</th>
                                <th>Volume (Forest m3)</th>
                                <th>mfub</th>
                                <th>Mean Trunk</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.renderSamples()}
                            </tbody>
                            <tfoot>
                            {this.renderSum()}
                            </tfoot>
                        </table>
                        <div style={{ float: "left", marginTop: 40, height: 300, width: 550}}>
                            Diameter distribution
                            {this.getSpecieOptions()}
                            <br />
                            <br />
                            <Chart data={getFormatFunction("colorless")(this.getTreesInHistogram())} chart="bar"/>
                        </div>
                        <div style={{ float: "left", marginTop: 40, height: 280, width: 250}}>
                            Specie distribution(no. trees)
                            <br />
                            <br />
                            <Chart data={getFormatFunction("colorful")(this.getTreesInPie())} chart="pie"/>
                        </div>
                    </div>
                </header>
                </div>
                <div style={{float: 'left', padding: 10, margin: 25, backgroundColor: "white", border: "1px solid lightgrey", display: "inline-block", height: (window.innerHeight - 220),
                    width: window.innerWidth - 1035,
                    position: "fixed"
                }}>
                    <div style={{width: "100%", height: 40, borderBottom: "1px solid black", fontSize: 20}}>Map</div>
                <div style={{position: "fixed", top: 175, border: "1px black solid"}}>
                    <MapWrapper samples={this.state.samples} summary={true} coordinates={{lat: this.state.samples[0].lat, lng: this.state.samples[0].lng}}/>
                </div>
                </div>
            </div>
        );
    }

    renderSum(){
        let allTrees = this.state.trees;
        return (
            <tr>
                <td style={{FontWeight: "bold"}}>Sum: </td>
                <td>{FC.dgv(allTrees.map(x => x.diameter)).toFixed(1)}</td>
                <td>{FC.mean(allTrees.map(x => x.height)).toFixed(1)}</td>
                <td>{FC.base_area(allTrees, FC.getHectareFromSamples(this.state.samples)).toFixed(1)}</td>
                <td>{/*FigureCalculator.volume(allTrees, radii, this.props.samples[0].latitude).toFixed(1)*/}</td>
                <td>{/*(FigureCalculator.m3fub(allTrees, radii, this.props.samples[0].latitude)*1000).toFixed(2)*/}</td>
                <td>{/*(FigureCalculator.meanTrunk(allTrees, FC.getHectareFromSamples(this.state.samples), this.props.samples[0].latitude)*1000).toFixed(2)*/}</td>
            </tr>
        )
    }

    getTreesInHistogram() {
        let data = []
        this.state.trees.sort((a,b) => a.diameter - b.diameter).forEach((tree) => {

            console.log(this.state.diameterDist)
            console.log(tree.english_name)
            if (this.state.diameterDist !== 'all') {
               if (tree.english_name !== this.state.diameterDist) {
                   return;
               }
            }

            // Floor diameter to closest even. i.e. diameter in range even -> even + 2
            let even = Math.floor(tree.diameter)
            if (even % 2 === 1) {
                even = even - 1;
            }

            if (data.filter(o => o.label === even + '-' + (even+2)).length === 1) {
                data.filter(o => o.label === even + '-' + (even+2)).forEach(o => o.amount += 1)
            } else {
                data.push({ amount: 1, label: even + '-' + (even+2) })
            }

        })
        let high = 0
        let low = 9000
        data.forEach(b => {
            if (b.label.split('-')[0] < low) {
                low = parseInt(b.label.split('-')[0])
            }
            if (b.label.split('-')[1] > high) {
                high = parseInt(b.label.split('-')[1])
            }
        })

        let data2 = []
        while (low < high) {
            if (data.filter(b => b.label === (low + '-' + (low + 2))).length === 0) {
                data2.push({amount: 0, label: low + '-' + (low + 2)})
            } else {
                data2.push(data.filter(b => b.label === (low + '-' + (low + 2)))[0])
            }
            low = low + 2
        }

        return data2
    }

    getTreesInPie() {
        let data = []
        this.state.trees.forEach((tree) => {
            if (data.filter(o => o.label === tree.english_name).length === 1) {
                data.filter(o => o.label === tree.english_name).forEach(o => o.amount += 1)
            } else {
                data.push({ amount: 1, label: tree.english_name })
            }

        })
        return data
    }

    getSpecieOptions() {
        let species = []
        this.state.trees.forEach((tree) => {
            if (species.filter(o => o === tree.english_name).length === 0) {
                species.push(tree.english_name)
            }
        });

        return (
            <select name="specie" id="specie" style={{ marginLeft: 10}}
               onChange={event => this.setState({diameterDist: event.target.value}) }
            >
                <option value="all">All Species</option>
                {species.map(s => <option value={s}>{s}</option>)}
            </select>
        )
    }

    renderSamples() {

        if (this.state.samples === undefined) {
            return null
        }

        let species = {};
        this.state.trees.map((tree)=> species.hasOwnProperty(tree.latin_name) ? species[tree.latin_name].push(tree) : species[tree.latin_name] = [tree]);

        return (Object.keys(species).map((name) =>
            <tr key={species[name][0].specie_id}>
                <td>{species[name][0].english_name}</td>
                <td>{FigureCalculator.dgv(species[name].map(x => x.diameter)).toFixed(1)}</td>
                <td>{FC.mean(species[name].map(x => x.height)).toFixed(1)}</td>
                <td>{FC.base_area(species[name], FC.areaToHectare(FC.getAreaFromSamples(this.state.samples))).toFixed(1)}</td>
                <td>{FC.volume(species[name], FC.getHectareFromSamples(this.state.samples), this.state.samples[0].latitude).toFixed(1)}</td>
                <td>{(FC.m3fub(species[name], FC.getHectareFromSamples(this.state.samples), this.state.samples[0].latitude)*1000).toFixed(2)}</td>
                <td>{(FC.meanTrunk(species[name], FC.getHectareFromSamples(this.state.samples), this.state.samples[0].latitude)*1000).toFixed(2)}</td>
            </tr>
        ))
    }
}
